export default function setLongLastingCookie (cookieName, value) {
  const expiration_date = new Date()
  expiration_date.setFullYear(expiration_date.getFullYear() + 1)
  const cookie_string = cookieName + '=' + JSON.stringify(value) + '; path=/; expires=' + expiration_date.toUTCString()
  document.cookie = cookie_string
}
